import React, { useState, useEffect, useContext } from "react";
import Menu from "../Section/Menu";
import { useNavigate } from "react-router-dom";
import ProfileImg from "../Image/profile-img.png";
import logo from "../Image/sislLogo.png";
import { UserContext } from "../UserContext";
import { getMenuLevel1 } from "../services/menuList";

export default function Header() {
  const navigate = useNavigate();
  const { username, isLoggedIn, operatorCode, logout } =
    useContext(UserContext);
  // alert(isLoggedIn+"islogin");
  useEffect(() => {
    // alert(isLoggedIn+"islogin");

    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);
  const [selectedSelectDropdown, setSelectedSelectDropdown] =
    useState("Select"); // State for 'Select' dropdown
  const [menuData, setMenuData] = useState(null);

  const handleSidebarToggle = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  const handleSelectDropdown = async (value, event) => {
    setSelectedSelectDropdown(value);
    sessionStorage.setItem("appName", value);

    // const result1 = await getData(value);
    const result = await getMenuLevel1(value, operatorCode);
    setMenuData(result);

    if (event && event.type === "click") {
      navigate("/");
    }

    // Update the menuData state
  };

  const handleSeasonDropdown = async (value, event) => {
    // const result = await getData(value);
    // setMenuData(result.data); // Update the menuData state
    sessionStorage.setItem("season", value);
    // if (event && event.type === 'click') {
    //   window.location.reload();
    //   alert(value);
    // }

  };
  const handleBacktoLogin = () => {
    logout();
    navigate("/login");
  };

  useEffect(() => {
    handleSelectDropdown("MASTER");
    handleSeasonDropdown("2425");
  }, []);
  return (
    <div>
      {/* ======= Header ======= */}
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="logo d-flex align-items-center">
            {/* <img src={logo} alt="" /> */}
            <img src={logo} alt="" />

            {/* <span className="d-none d-lg-block">NSWS MODULE</span> */}
            <span className="d-none d-lg-block" style={{ fontSize: "1.1em" }}>
              NSWS API INTEGRATION
            </span>
          </div>
          <i
            className="bi bi-list toggle-sidebar-btn"
            onClick={handleSidebarToggle}
          />
        </div>
        <div className="header-mill d-none d-md-flex">
          <i className="bi bi-building" aria-hidden="true" />
          <span>{sessionStorage.getItem("clientName")}</span>
        </div>

        {/* <div>
          <ul className="nav nav-tabs">
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                {selectedSeasonDropdown}
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#" onClick={(event) =>  handleSeasonDropdown('2223', event)}>2022-2023</a></li>
                <li><a className="dropdown-item" href="#" onClick={(event) =>  handleSeasonDropdown('2324', event)}>2023-2024</a></li>
                <li><a className="dropdown-item" href="#" onClick={(event) =>  handleSeasonDropdown('2425', event)}>2024-2025</a></li>
              </ul>
            </li>
          </ul>
        </div> */}

        <nav className="header-nav ms-auto flex flex-row">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown pe-3">
              <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                href="#"
                data-bs-toggle="dropdown"
              >
                <img
                  src={ProfileImg}
                  alt="Profile"
                  className="rounded-circle"
                />
                <span className="d-none d-md-block dropdown-toggle ps-2">
                  {username}
                </span>
              </a>
              {/* End Profile Image Icon */}
              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                <li className="dropdown-header">
                  <h6>{username}</h6>
                  <span>{sessionStorage.getItem("clientName")}</span>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item d-flex align-items-center"
                    href="#"
                    onClick={handleBacktoLogin}
                  >
                    <i className="bi bi-box-arrow-right" />
                    <span>Sign Out</span>
                  </a>
                </li>
              </ul>
              {/* End Profile Dropdown Items */}
            </li>
            {/* End Profile Nav */}
          </ul>
        </nav>
        {/* End Icons Navigation */}
      </header>
      {/* End Header */}

      {/* Render Menu component with the fetched data */}
      {menuData && <Menu menuData={selectedSelectDropdown} />}

      {/* {menuData && <Dashboard menuData={menuData} />} */}
    </div>
  );
}
